import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Benefits from "@/components/sections/Benefits";
import TrustBar from "@/components/sections/TrustBar";
import Manifesto from "@/components/sections/Manifesto";
import FocusPreview from "@/components/sections/FocusPreview";
import Comparison from "@/components/sections/Comparison";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import { Toaster } from "sonner";

function Landing() {
  return (
    <div className="bg-off text-ink relative min-h-screen">
      <SmoothScroll>
        <Navbar />
        <main data-testid="landing-main" className="pt-16 md:pt-20">
          <Hero />
          <Manifesto />
          <Benefits />
          <TrustBar />
          <FocusPreview />
          <Comparison />
          <Contact />
        </main>
        <Footer />
      </SmoothScroll>
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#0F1A2A",
            border: "1px solid #E6DFCE",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "10px",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
